let getAmountOfOrderAndSale;
function initDisabledTooltips() {
  $('.return-order-button').each(function () {
    if ($(this).is(':disabled')) {
      $(this).attr(
        'title',
        'Verifone-integrasjon er deaktivert. Returordre kan ikke behandles.'
      );
    } else {
      $(this).attr('title', '');
    }
  });
}

$(document).ready(function () {
  let filterByFromQuery = $('body').attr('filter_by') || null;
  let startDateFromQuery = $('body').attr('start_date') || null;
  let endDateFromQuery = $('body').attr('end_date') || null;
  let customPeriodFromQuery = $('body').attr('custom_period') || null;
  let prevSelectedPeriodFromQuery =
    $('body').attr('prev_selected_period') || null;

  if (
    p == 'order_confirmation' ||
    p == 'organizer_event_customers' ||
    p == 'statistic_order' ||
    p == 'today_orders' ||
    p == 'events'
  ) {
    if (localStorage.getItem('returningOrderData')) {
      const { orderId, addStockBack, returnedOrderId, isDeleteOrder } =
        JSON.parse(localStorage.getItem('returningOrderData'));
      getOrderPaymentSplitModal(
        orderId,
        addStockBack,
        returnedOrderId,
        true,
        isDeleteOrder
      );
    }

    $(document).on(
      'show.bs.modal',
      '#returnOrderPaymentSplitModel',
      function () {
        fixBackdrops();
      }
    );

    $(document).on(
      'hide.bs.modal',
      '#returnOrderPaymentSplitModel',
      function () {
        restoreBackdrops();
      }
    );

    $(document).on('click', '.return-order-button', function () {
      const orderIdToReturn = $(this).attr('data-order-id');
      const paymentMethodToReturn = $(this).attr('data-payment-method');
      const terminalId = $(this).attr('data-terminal-id') || null;
      const isOndeviceTerminalOrder =
        ($(this).attr('data-is-on-device-terminal-order') || '0') == '1';
      const isClosedZReport =
        ($(this).attr('data-is-closed-z-report') || '0') == '1';

      $('#return-order-modal').removeAttr('data-terminal-id');
      $('#return-order-modal').attr(
        'data-is-closed-z-report',
        isClosedZReport ? '1' : '0'
      );

      $('#return_with_payment_original, #return_with_cash').prop(
        'disabled',
        false
      );

      if (
        ($('body').attr('is_verifone') == 1 || $('body').attr('is_pax') == 1) &&
        localStorage.getItem('temrinalUniqueId') &&
        terminalId
      ) {
        const temrinalUniqueId = localStorage.getItem('temrinalUniqueId');

        if (temrinalUniqueId !== terminalId) {
          showToast({
            type: 'warning',
            title: 'Retur ikke tillatt !',
            message: `Bestillingen ble opprettet på en annen enhet. Bruk original enhet for retur`,
            duration: 4000,
          });
          return;
        }
      }

      if (terminalId && isOndeviceTerminalOrder) {
        $('#return-order-modal').attr('data-terminal-id', terminalId);
      }

      $('.return-order-confirm-btn').attr('data-order-id', orderIdToReturn);
      $('.return-order-confirm-btn').attr(
        'data-payment-method',
        paymentMethodToReturn
      );

      $('#return-order-modal')
        .off('shown.bs.modal')
        .on('shown.bs.modal', function () {
          if (
            isOndeviceTerminalOrder &&
            $('body').attr('is_verifone') !== '1' &&
            $('body').attr('is_pax') !== '1'
          ) {
            checkTerminalAvailability('return_order');
          }
        })
        .modal('show');
    });

    $(document).on('click', '.return-order-confirm-btn', function (e) {
      e.preventDefault();

      const orderId = $(this).attr('data-order-id');
      const addStockBack = $(this).attr('data-add-back-stock');
      const isReturnWithCash = $('#return_with_cash').is(':checked');
      const paymentMethod = $(this).attr('data-payment-method');
      const returnedOrderId =
        $('#returnOrderPaymentSplitModel').attr('data-returned-order-id') ||
        null;
      const isClosedZReport =
        $('#return-order-modal').attr('data-is-closed-z-report') == '1';

      const confirmationMessage = isClosedZReport
        ? 'Denne handelen er inkludert i et avsluttet dagsoppgjør (Z-rapport). Returen registreres som en ny negativ handel i dagens oppgjør. Den opprinnelige handelen og den avsluttede Z-rapporten blir ikke endret. Vil du fortsette?'
        : `Er du sikker på at du vil returnere denne bestillingen med ${isReturnWithCash ? 'kontant' : 'original betaling'}?`;

      $('#return-order-modal')
        .one('hidden.bs.modal', function () {
          customConfirm(confirmationMessage, 'warning').then(function (ok) {
            if (!ok) {
              $('#return-order-modal, #confirmModal').css('z-index', '');
              if ($('.modal.show').length === 0) {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open').css('padding-right', '');
              }
              return;
            }

            if (paymentMethod == 9 && !isReturnWithCash) {
              getOrderPaymentSplitModal(
                orderId,
                addStockBack,
                returnedOrderId,
                false,
                0,
                isClosedZReport
              );
            } else {
              $('.return-order-progress-section').removeClass('d-none');
              $('.return-order-success-section').addClass('d-none');
              $('.return-error-message-section').addClass('d-none');
              $('.return-order-progress-action-btn').prop('disabled', true);

              document.activeElement?.blur();

              setTimeout(function () {
                $('#return-order-progress-modal').modal('show');

                returnOrder(
                  orderId,
                  addStockBack,
                  isReturnWithCash,
                  isClosedZReport
                );
              }, 300);
            }
          });
        })
        .modal('hide');
    });

    $(document).on('click', '.delete-order-confirm-btn', function (e) {
      e.preventDefault();
      const cancelButton = $(this);
      const orderId = cancelButton.attr('data-order-id');
      const addStockBack = cancelButton.attr('data-add-back-stock');
      const paymentMethod = cancelButton.attr('data-payment-method');

      customConfirm(
        `Er du sikker på at du vil slette denne bestillingen?`,
        'warning'
      ).then(function (confirmed) {
        if (!confirmed) {
          $('.delete-order-confirm-btn').prop('disabled', false);
          $('#last-order-delete-cancel').prop('disabled', false);
          return;
        }

        if (paymentMethod == 9) {
          getOrderPaymentSplitModal(orderId, addStockBack, null, false, 1);
        } else {
          $('.delete-order-confirm-btn').prop('disabled', true);
          $('#last-order-delete-cancel').prop('disabled', true);
          cancelButton.html(
            `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> `
          );

          $.ajax({
            type: 'POST',
            url: '/api/v1/private/order/return-order',
            data: {
              orderId,
              addStockBack,
              isDeleteOrder: 1,
            },
          })
            .done(function (data) {
              if (data && data.success) {
                if (data.order && data.orderProducts) {
                  const orderReturn = data.order;
                  const orderProductsReturn = data.orderProducts;
                  const totalPrice = formattedPriceToShow(
                    parseFloat(orderReturn.price_ex_vat_total) +
                      parseFloat(orderReturn.vat_total)
                  );
                  const productsWithCount = [];

                  orderProductsReturn.forEach((product) => {
                    const productDetail = `(${product.quantity})${product.name}`;
                    productsWithCount.push(productDetail);
                  });
                  localStorage.setItem(
                    'lastOrderProducts',
                    JSON.stringify(productsWithCount)
                  );
                  localStorage.setItem('lastOrderTotal', totalPrice);
                }
                $('#model-body-message').hide();
                $('#last-order-delete-cancel').hide();
                $('#cancel-last-order').hide();
                $('#cancel-last-order-confirm-modal').modal('hide');
                $('.modal-backdrop').remove();
                $('#cancel-last-order-information').empty();
                $('#cancel-last-order-information').html(`
                  <div class="d-flex flex-column align-items-center">
                      <div>
                          <i class="material-icons" style="font-size: 5rem; color: green;">check_circle_outline</i>
                      </div>
                      <div style="color: green; font-size: 1.2rem;">${data.success}</div>
                  </div>
                  `);

                setTimeout(() => {
                  $(`#order-product-order-id-${orderId}`).fadeOut(500);
                  const $menuLinks = $('#menuLinks');
                  if ($menuLinks.hasClass('show')) {
                    $menuLinks.collapse('hide');
                  }

                  setLastOrderDetails();
                }, 2000);
              } else if (data && data.refund_data) {
                localStorage.setItem(
                  'verifone_refund_data',
                  JSON.stringify(data.refund_data)
                );
                if (
                  $('body').attr('is_verifone') == 1 ||
                  $('body').attr('is_pax') == 1
                ) {
                  passVerifoneDataToWebView(data.refund_data);
                } else {
                  const payload = {
                    type: 'verifone',
                    action: 'start_refund',
                    temrinalUniqueId: data.refund_data.verifoneId,
                    paymentData: data.refund_data,
                    senderDeviceId: localStorage.getItem('deviceID'),
                  };

                  window.globalSocket.send(JSON.stringify(payload));
                }
              } else if (data && data.error) {
                $('#model-body-message').hide();
                $('#last-order-delete-cancel').hide();
                $('#cancel-last-order').hide();
                $('#cancel-last-order-information').empty();
                $('#cancel-last-order-information').html(`
            <div class="d-flex flex-column align-items-center">
                <div>
                    <i class="material-icons" style="font-size: 3rem; color: red;">error_outline</i>
                </div>
                <div style="color: red; font-size: 1.2rem; text-align: center;">${data.error}</div>
            </div>
            `);

                setTimeout(() => {
                  $('#cancel-last-order-confirm-modal').modal('hide');
                }, 5000);
              }
            })
            .fail(function (data) {
              const errorMessage =
                data && data.responseJSON
                  ? data.responseJSON.error || data.responseJSON.error_message
                  : null;
              if (errorMessage) {
                $('#model-body-message').hide();
                $('#last-order-delete-cancel').hide();
                $('#cancel-last-order').hide();
                $('#cancel-last-order-information').empty();
                $('#cancel-last-order-information').html(`
            <div class="d-flex flex-column align-items-center">
                <div>
                    <i class="material-icons" style="font-size: 3rem; color: red;">error_outline</i>
                </div>
                <div style="color: red; font-size: 1.2rem; text-align: center;">${errorMessage}</div>
            </div>
            `);

                setTimeout(() => {
                  $('#cancel-last-order-confirm-modal').modal('hide');
                }, 5000);
              }
            });
        }
      });
    });

    $(document).on('click', '.order-payment-split-return-button', function (e) {
      e.preventDefault();
      const terminalId = $(this).attr('data-terminal-id') || null;
      if (
        $('body').attr('is_verifone') &&
        localStorage.getItem('temrinalUniqueId') &&
        terminalId
      ) {
        const temrinalUniqueId = localStorage.getItem('temrinalUniqueId');

        if (temrinalUniqueId !== terminalId) {
          showToast({
            type: 'warning',
            title: 'Retur ikke tillatt !',
            message: `Bestillingen ble opprettet på en annen enhet. Bruk original enhet for retur`,
            duration: 4000,
          });
          return;
        }
      }

      const orderId = $(this).attr('data-order-id');
      const orderPaymentSplitId = $(this).attr('data-order-payment-split-id');
      const addStockBack = $(this).attr('data-add-back-stock');
      const paymentMethod = $(this).attr('data-payment-method');
      const isDeleteOrder = $(this).attr('data-is-delete-order') || 0;
      const closedZReportConfirmed =
        ($(this).attr('data-closed-z-report-confirmed') || '0') == '1';
      const parentDiv = $(this).closest('.order-payment-split-return-section');
      const returnedOrderId =
        $('#returnOrderPaymentSplitModel').attr('data-returned-order-id') ||
        null;
      const button = $(this);
      const btnWidth = button.outerWidth();
      button.css('width', btnWidth + 'px');
      button.prop('disabled', true);
      $('.order-payment-split-return-button').prop('disabled', true);
      button.html('<i class="spinner-border spinner-border-sm"></i>');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/order/return-order-payment-split',
        data: {
          orderId,
          orderPaymentSplitId,
          addStockBack,
          paymentMethod,
          returnedOrderId,
          isDeleteOrder,
          closedZReportConfirmed: closedZReportConfirmed ? 1 : 0,
        },
      })
        .done(function (data) {
          button.removeClass('btn-primary');
          button.addClass('btn-success');
          button.html('✓');
          if (data && data.isFullyReturned) {
            localStorage.removeItem('returningOrderData');
            $('#returnOrderPaymentSplitModel').modal('hide');
            popupAlert();
            if (p == 'statistic_order') {
              getAmountOfOrderAndSale(
                startDate,
                endDate,
                period,
                supplierId,
                productGroupUniqueId,
                locationId,
                userId,
                platform,
                customPeriod,
                topProductGroupUniqueId,
                customerId,
                compareBy,
                productId,
                vatCode,
                paymentMethod
              );
              $('.modal-backdrop').remove();
            } else if (
              data &&
              data.redirect_url &&
              data.success &&
              isDeleteOrder != 1
            ) {
              document.location.href = data.redirect_url;
            }
          } else if (data && data.returnedOrderId && !data.refund_data) {
            $('#returnOrderPaymentSplitModel .close').addClass('d-none');
            $('#returnOrderPaymentSplitModel').attr(
              'data-returned-order-id',
              data.returnedOrderId
            );
            localStorage.setItem(
              'returningOrderData',
              JSON.stringify({
                orderId,
                addStockBack,
                returnedOrderId: data.returnedOrderId,
                isDeleteOrder,
              })
            );
            button.attr('data-is-paid', 1);

            $(".order-payment-split-return-button[data-is-paid='0']").prop(
              'disabled',
              false
            );
            button.prop('disabled', true);
            $('.return-order-error').remove();
          } else if (data && data.refund_data) {
            localStorage.setItem(
              'verifone_refund_data',
              JSON.stringify(data.refund_data)
            );

            if ($('body').attr('is_verifone')) {
              passVerifoneDataToWebView(data.refund_data);
            } else {
              const payload = {
                type: 'verifone',
                action: 'start_refund',
                temrinalUniqueId: data.refund_data.verifoneId,
                paymentData: data.refund_data,
                senderDeviceId: localStorage.getItem('deviceID'),
              };

              window.globalSocket.send(JSON.stringify(payload));
            }
          }
        })
        .fail(function (data) {
          button.html('Retur');
          button.prop('disabled', false);
          let errorMessage = 'An error occured';

          if (
            data.responseJSON.errors !== undefined &&
            data.responseJSON.errors !== null
          ) {
            errorMessage = data.responseJSON.errors;
          }

          const alertDiv = `<div class="alert alert-danger alert-dismissible return-order-error" role="alert">
          <a href="#" class="close" data-dismiss="alert" aria-label="close">×</a>
                                ${errorMessage}
                             </div>`;
          parentDiv.after(alertDiv);
        });
    });

    $(document).on('click', '.return-order-retry-btn', function (e) {
      e.preventDefault();
      const orderId = $(this).attr('data-order-id');
      const addStockBack = $(this).attr('ddata-add-back-stock');
      const isReturnWithCash = $('#return_with_cash').is(':checked');
      const isClosedZReport =
        $('#return-order-modal').attr('data-is-closed-z-report') == '1';
      $('.return-order-progress-section').removeClass('d-none');
      $('.return-error-message-section').addClass('d-none');
      returnOrder(orderId, addStockBack, isReturnWithCash, isClosedZReport);
    });

    function returnOrder(
      orderId,
      addStockBack,
      isReturnWithCash = false,
      closedZReportConfirmed = false
    ) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/order/return-order',
        data: {
          orderId,
          addStockBack,
          isReturnWithCash: isReturnWithCash ? 1 : 0,
          closedZReportConfirmed: closedZReportConfirmed ? 1 : 0,
        },
      })
        .done(function (data) {
          if (data && data.success) {
            $('.return-order-success-section ').removeClass('d-none');
            $('.return-order-progress-section').addClass('d-none');

            setTimeout(() => {
              if (p == 'statistic_order') {
                getAmountOfOrderAndSale(
                  startDate,
                  endDate,
                  period,
                  supplierId,
                  productGroupUniqueId,
                  locationId,
                  userId,
                  platform,
                  customPeriod,
                  topProductGroupUniqueId,
                  customerId,
                  compareBy,
                  productId,
                  vatCode,
                  paymentMethod
                );
                $('.modal-backdrop').remove();
              } else if (p == 'today_orders') {
                $('#return-order-progress-modal').modal('hide');
                $(`tr[data-order-id="${orderId}"]`).fadeOut(400, function () {
                  $(this).remove();
                });
                $(`ul[data-order-id="${orderId}"]`).fadeOut(400, function () {
                  $(this).remove();
                });
              } else if (data.redirect_url) {
                document.location.href = data.redirect_url;
              }

              $('#return-order-progress-model').modal('hide');
            }, 1000);
          } else if (data && data.refund_data) {
            localStorage.setItem(
              'verifone_refund_data',
              JSON.stringify(data.refund_data)
            );
            if (
              $('body').attr('is_verifone') == 1 ||
              $('body').attr('is_pax') == 1
            ) {
              passVerifoneDataToWebView(data.refund_data);
            } else {
              const payload = {
                type: 'verifone',
                action: 'start_refund',
                temrinalUniqueId: data.refund_data.verifoneId,
                paymentData: data.refund_data,
                senderDeviceId: localStorage.getItem('deviceID'),
              };

              window.globalSocket.send(JSON.stringify(payload));
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.errors !== undefined &&
            data.responseJSON.errors !== null
          ) {
            let errorMessage = '';
            if (data.responseJSON.errors.includes('/')) {
              errorMessage = data.responseJSON.errors.split('/')[0];
            } else {
              errorMessage = data.responseJSON.errors;
            }
            $('.return-order-progress-section').addClass('d-none');
            $('.return-error-message-section').removeClass('d-none');
            $('.return-error-message-section .return-error-message').text(
              errorMessage
            );
          }
        })
        .always(function () {
          $('.return-order-progress-action-btn').prop('disabled', false);
        });
    }

    function getOrderPaymentSplitModal(
      orderId,
      addStockBack,
      returnedOrderId,
      disbaledClose = false,
      isDeleteOrder = 0,
      closedZReportConfirmed = false
    ) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/order/get-order-payment-split-return-modal',
        data: {
          orderId,
          addStockBack,
          returnedOrderId,
          disbaledClose,
          isDeleteOrder,
          closedZReportConfirmed: closedZReportConfirmed ? 1 : 0,
        },
      })
        .done(function (data) {
          if (data.html) {
            $('#return-order-modal').modal('hide');
            if ($('#returnOrderPaymentSplitModel').length) {
              $('#returnOrderPaymentSplitModel').remove();
            }
            $('#content').append(data.html);
            $('#returnOrderPaymentSplitModel').modal('show');
            if (disbaledClose) {
              $('#returnOrderPaymentSplitModel .close').remove();
            }
            if ($('#cancel-last-order-confirm-modal').length) {
              $('#cancel-last-order-confirm-modal').remove();
            }
          }
        })
        .fail(function (data) {});
    }
  }

  if (p === 'statistic_order') {
    getAmountOfOrderAndSale = function (
      startDate,
      endDate,
      period = null,
      supplierId = null,
      productGroupUniqueId = null,
      locationId = 'all',
      userId = null,
      platform = 'all',
      customPeriod,
      topProductGroupUniqueId = 0,
      customerId = 0,
      compareBy = null,
      productId = 0,
      vatCode = 0,
      paymentMethod = 0,
      productCategoryId = 0,
      selectedDay = null,
      page = 1,
      getHtml = 0
    ) {
      const minimumOrderAmount = ($('#order-amount-from').val() || '').trim();
      const maximumOrderAmount = ($('#order-amount-to').val() || '').trim();
      const productSearchText = ($('#order-product-search').val() || '').trim();

      $.ajax({
        type: 'POST',
        url: '/ajax/statistic_order/search',
        data: {
          startDate,
          endDate,
          period,
          supplierId,
          productGroupUniqueId,
          locationId,
          userId,
          platform,
          customPeriod,
          topProductGroupUniqueId,
          customerId,
          compareBy,
          productId,
          vatCode,
          paymentMethod,
          productCategoryId,
          selectedDay,
          minimumOrderAmount,
          maximumOrderAmount,
          productSearchText,
          page,
          get_page_html: getHtml,
        },
      })
        .done(function (data) {
          if (!getHtml) {
            if (data.totalQuantity) {
              $('#key-figure-sale').text(data.totalQuantity);
              $('#key-figure-order').text(data.totalQuantity);
            } else {
              $('#key-figure-sale').text('0');
              $('#key-figure-order').text('0');
            }
            if (
              data.xAxisArray.length > 0 &&
              data.seriesData1 &&
              data.seriesData2
            ) {
              exportDateData = data.xAxisArray;
              exportOrderData = data.seriesData1;
              eventLineChart(
                data.xAxisArray,
                data.seriesData1,
                data.seriesData2
              );
            }
            let aTags = $('.statistic-tab-group a');
            aTags.each(function () {
              let oldHref = $(this).attr('href').split('?')[0];
              let newHref =
                oldHref +
                `?filter_by=${period}&custom_period=${customPeriod}&prev_selected_period=${prevSelectedPeriod}&start_date=${startDate}&end_date=${endDate}`;
              $(this).prop('href', newHref);
            });
          }

          if (
            data &&
            data.html !== undefined &&
            data.html !== null &&
            data.html !== ''
          ) {
            $('#order-list-view').html(data.html);
            initDisabledTooltips();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    };

    function refreshOrderStatistics() {
      getAmountOfOrderAndSale(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId
      );
    }

    $(document).on(
      'change',
      '#order-amount-from, #order-amount-to',
      function () {
        refreshOrderStatistics();
      }
    );

    let productSearchTimeout;
    $(document).on('input', '#order-product-search', function () {
      clearTimeout(productSearchTimeout);
      productSearchTimeout = setTimeout(refreshOrderStatistics, 400);
    });

    $(document).on(
      'submit',
      '#statistic-order-purchase-filter-form',
      function (e) {
        e.preventDefault();
        clearTimeout(productSearchTimeout);
        refreshOrderStatistics();
      }
    );

    $('#filter')
      .on('show.bs.collapse', function () {
        $('#statistic-order-purchase-filter-form').collapse('show');
      })
      .on('hide.bs.collapse', function () {
        $('#statistic-order-purchase-filter-form').collapse('hide');
      });

    setDateAndPeriod(
      startDateFromQuery,
      endDateFromQuery,
      filterByFromQuery,
      customPeriodFromQuery,
      prevSelectedPeriodFromQuery
    );
    handleCustomerIdChange(getAmountOfOrderAndSale);
    handleCustomPeriodChange(getAmountOfOrderAndSale);
    handleTopProductGroupChange(getAmountOfOrderAndSale);
    handleSupplierIdChange(getAmountOfOrderAndSale);
    handleProductGroupChange(getAmountOfOrderAndSale);
    handleUserChange(getAmountOfOrderAndSale);
    handlePlatformChange(getAmountOfOrderAndSale);
    handlePeriodChange(getAmountOfOrderAndSale);
    handleDateAndTimeChange(getAmountOfOrderAndSale);
    handlePreviousButton(getAmountOfOrderAndSale);
    handleNextButton(getAmountOfOrderAndSale);
    handleCompareByChange(getAmountOfOrderAndSale);
    handleProductChange(getAmountOfOrderAndSale);
    handlePaymentChange(getAmountOfOrderAndSale);
    handleVatCodeChange(getAmountOfOrderAndSale);
    handleLocationChange(getAmountOfOrderAndSale);
    handleCustomDayChange(getAmountOfOrderAndSale);
    handleProductCategoryChange(getAmountOfOrderAndSale);
    let total1 = 0;
    let exportDateData = [];
    let exportOrderData = [];
    let htmlData = [];

    $(document).on('click', '#download-statistic-excel', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getOrderHtmlData();
      $.ajax({
        url: '/api/v1/private/statistics/download-statistic-excel',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          export_date_data: exportDateData,
          export_order_data: exportOrderData,
          start_date: startDate,
          end_date: endDate,
          export_type: 'order',
          html_data: htmlData,
          total_order: total1,
        }),
        xhrFields: { responseType: 'blob' }, // important for binary data
        success: function (data) {
          // Check if running in React Native WebView
          if (window.ReactNativeWebView) {
            // Convert blob to base64
            const reader = new FileReader();
            reader.onloadend = function () {
              const base64Data = reader.result.split(',')[1];
              const filename = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;

              // Send to React Native
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: 'download',
                  data: {
                    base64Data,
                    filename: filename,
                    mimeType:
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  },
                })
              );
            };
            reader.readAsDataURL(data);
          } else {
            // Standard browser download
            const blob = new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).xlsx`;
            link.click();
          }
        },
        error: function () {
          alert('Error generating Excel file');
        },
        complete: function () {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html('Last ned(excel)');
        },
      });
    });

    $(document).on('click', '#download-statistic-pdf', function () {
      const disabledOnClick = $(this);
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      htmlData = getOrderHtmlData();
      if (!chartComponent) {
        alert('Chart not ready');
        disabledOnClick.prop('disabled', false).html('Last ned(pdf)');
        return;
      }

      // Convert Highcharts SVG to PNG
      const svg = chartComponent.getSVG();
      const img = new Image();
      img.onload = function () {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        const pngData = canvas.toDataURL('image/png'); // base64 PNG

        // Prepare payload using your Excel-style fields + chart PNG
        const payload = {
          export_date_data: exportDateData,
          export_order_data: exportOrderData,
          export_type: 'order',
          html_data: htmlData,
          total_order: total1,
          chart_png: pngData, // PNG included
        };

        // AJAX POST to generate PDF
        $.ajax({
          url: '/api/v1/private/statistics/download-statistic-pdf',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(payload),
          xhrFields: { responseType: 'blob' }, // receive PDF
          success: function (data) {
            if (window.ReactNativeWebView) {
              // Convert blob to base64
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64Data = reader.result.split(',')[1]; // Remove data:*/*;base64, prefix
                const filename = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;

                // Send to React Native
                window.ReactNativeWebView.postMessage(
                  JSON.stringify({
                    action: 'download',
                    data: {
                      base64Data,
                      filename: filename,
                      mimeType: 'application/pdf',
                    },
                  })
                );
              };
              reader.readAsDataURL(data);
            } else {
              const blob = new Blob([data], { type: 'application/pdf' });
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = `Statistikk ordre (${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}).pdf`;
              link.click();
            }
          },
          error: function () {
            alert('Error generating PDF');
          },
          complete: function () {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html('Last ned(pdf)');
          },
        });
      };

      // Encode SVG for PNG conversion
      img.src =
        'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
    });

    function getOrderHtmlData() {
      let htmlData = [];
      $('.mobile-view .list-group').each(function () {
        let $li = $(this).find('li');

        let table = $li.eq(0).text().replace('Bord :', '').trim();
        let ref = $li.eq(1).text().replace('Ref :', '').trim();
        let date = $li.eq(2).text().replace('Dato :', '').trim();
        let order = [];
        $li
          .eq(3)
          .find('.product-name p')
          .each(function () {
            let text = $(this).text().replace(/\s+/g, ' ').trim();
            order.push(text);
          });
        let totalText = $li
          .eq(4)
          .text()
          .replace('Totalt:', '')
          .replace(/\s+/g, '')
          .replace('kr', '')
          .replace(',', '.');
        let total = parseFloat(totalText);

        htmlData.push({ table, ref, date, order, total });
      });
      return htmlData;
    }

    function eventLineChart(categoryArray, seriesData1, seriesData2) {
      const { legendText, previousLegendText } = getLegendTexts(
        compareBy,
        startDate
      );
      // Calculate totals
      total1 = seriesData1.reduce((sum, val) => sum + floor(val), 0);
      const total2 = seriesData2
        ? seriesData2.reduce((sum, val) => sum + floor(val), 0)
        : 0;

      chartComponent = Highcharts.chart('event-line-graph', {
        chart: {
          type: 'column',
        },
        title: {
          text: null,
        },

        exporting: {
          enabled: false,
          buttons: {
            contextButton: {
              menuItems: [
                {
                  text: 'Last ned PDF',
                  onclick: function () {
                    this.exportChart({ type: 'application/pdf' });
                  },
                },
                {
                  text: 'Last ned Excel',
                  onclick: function () {
                    const chart = this;

                    // Get the default table
                    const table = chart.getTable();

                    // Parse the existing table to extract data
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(table, 'text/html');
                    const rows = doc.querySelectorAll('tr');

                    let csvContent = '';

                    // Add BOM for proper UTF-8 encoding in Excel
                    csvContent = '\uFEFF';

                    // Add custom header rows
                    csvContent += 'Statistikk: Ordrebeløp \n';
                    csvContent += startDate + ' - ' + endDate + '\n';
                    csvContent +=
                      'Generert:,' + new Date().toLocaleString('no-NO') + '\n';
                    csvContent += '\n'; // Empty row

                    // Add table header and data rows
                    rows.forEach((row, index) => {
                      const cells = row.querySelectorAll('th, td');
                      const rowData = [];

                      cells.forEach((cell) => {
                        let cellText = cell.textContent.trim();
                        // Fix the "Chart" header issue
                        if (cellText === 'Chart' || cellText === 'Category') {
                          cellText = 'Dato';
                        }
                        rowData.push(cellText);
                      });

                      if (rowData.length > 0) {
                        csvContent += rowData.join(',') + '\n';
                      }
                    });

                    // Add custom footer rows
                    csvContent += 'Totalt,' + total1 + '\n';
                    csvContent += '\n';
                    csvContent += 'Dato,' + 'Ordre' + ',' + 'Totalt' + '\n';
                    csvContent +=
                      '"12/09/2025 18:23:34",' +
                      '"2 x cake\n1 x cola\n1 x tea",' +
                      '"173 kr"' +
                      '\n';

                    if (seriesData2 && total2 > 0) {
                      csvContent +=
                        'Totalt forrige ' +
                        getPeriodTranslation(compareBy ?? '', startDate) +
                        ',' +
                        total2 +
                        '\n';
                    }

                    // Create and download the file with proper UTF-8 encoding
                    const blob = new Blob([csvContent], {
                      type: 'text/csv;charset=utf-8;',
                    });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute(
                      'download',
                      'Ordrebeløp_' +
                        startDate.replace(/[^a-zA-Z0-9]/g, '_') +
                        '_' +
                        endDate.replace(/[^a-zA-Z0-9]/g, '_') +
                        '.csv'
                    );
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                  },
                },
              ],
            },
          },
        },

        plotOptions: {
          series: {
            lineWidth: 4,
          },
        },
        xAxis: {
          categories: categoryArray,
          labels: {
            formatter: function () {
              if (customPeriod === 'day') {
                return Highcharts.dateFormat(
                  '%e/%b',
                  new Date(this.value).getTime()
                );
              } else if (customPeriod === 'week') {
                return 'Uke ' + this.value;
              } else if (customPeriod === 'month') {
                return Highcharts.dateFormat(
                  '%B %Y',
                  new Date(this.value).getTime()
                );
              } else {
                return this.value;
              }
            },
          },
        },
        credits: { enabled: false },
        yAxis: {
          title: {
            text: 'Ordrebeløp',
          },
        },
        series:
          !compareBy || compareBy == '0'
            ? [
                {
                  name: 'Ordrebeløp',
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
              ]
            : [
                {
                  name: `Ordrebeløp ( ${total1} ) ${legendText}`,
                  data: seriesData1.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
                {
                  name: `Ordrebeløp forrige ${getPeriodTranslation(
                    compareBy ?? '',
                    startDate
                  )} ( ${total2} ) ${previousLegendText}`,
                  data: seriesData2.map((value, index) => [
                    categoryArray[index],
                    floor(value),
                  ]),
                },
              ],
        tooltip: {
          formatter: function () {
            var tooltipText;
            if (startDate.split(' ')[0] === endDate.split(' ')[0]) {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%H:%M, %b %e', this.x) +
                '</b><br/>' +
                'Handler : ' +
                formatNumber(this.y);
            } else if (customPeriod === 'week') {
              tooltipText =
                '<b>' +
                'Uke' +
                ' ' +
                this.x +
                '</b><br/>' +
                'Handler : ' +
                formatNumber(this.y);
            } else if (customPeriod === 'month') {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%B - %Y', this.x) +
                '</b><br/>' +
                'Handler : ' +
                formatNumber(this.y);
            } else {
              tooltipText =
                '<b>' +
                Highcharts.dateFormat('%A, %b %e, %Y', this.x) +
                '</b><br/>' +
                'Handler : ' +
                formatNumber(this.y);
            }
            return tooltipText;
          },
        },
      });
    }

    function toggleCustomDatePicker() {
      let customDatePicker = $('.custom-date-picker');

      if (period === 'custom') {
        customDatePicker.show();
      } else {
        customDatePicker.hide();
      }
    }

    $(document).on('click', '.pagination a', function (e) {
      e.preventDefault();
      let page = parseInt($(this).attr('href').substring(6));
      getAmountOfOrderAndSale(
        startDate,
        endDate,
        period,
        supplierId,
        productGroupUniqueId,
        locationId,
        userId,
        platform,
        customPeriod,
        topProductGroupUniqueId,
        customerId,
        compareBy,
        productId,
        vatCode,
        paymentMethod,
        productCategoryId,
        null,
        page,
        1
      );
    });

    getAmountOfOrderAndSale(
      startDate,
      endDate,
      period,
      supplierId,
      productGroupUniqueId,
      locationId,
      userId,
      platform,
      customPeriod,
      topProductGroupUniqueId,
      customerId,
      compareBy,
      productId,
      vatCode,
      paymentMethod,
      productCategoryId
    );
    toggleCustomDatePicker();
  }
});
